// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../../../toeic/commerce/Goods";
import { name2num, num2name, } from "./(SubscriptionProduct)/RenewalInterval";
import { encodeJson as encodeJson_2, decodeJson as decodeJson_2, encodeBinary as encodeBinary_2, decodeBinary as decodeBinary_2, } from "./(SubscriptionProduct)/SaleConfig";
import { encodeJson as encodeJson_3, decodeJson as decodeJson_3, encodeBinary as encodeBinary_3, decodeBinary as decodeBinary_3, } from "../../../../toeic/commerce/(Product)/PaymentConfig";
import { encodeJson as encodeJson_4, decodeJson as decodeJson_4, encodeBinary as encodeBinary_4, decodeBinary as decodeBinary_4, } from "../../../../toeic/commerce/(Product)/DisplayConfig";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../runtime/json/scalar";
import { WireType, } from "../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../../runtime/wire/scalar";
import { default as Long, } from "../../../../../runtime/Long";
import { default as deserialize, } from "../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        id: "0",
        goods: [],
        renewalInterval: "RENEWAL_INTERVAL_UNSPECIFIED",
        saleConfig: undefined,
        paymentConfig: undefined,
        displayConfig: undefined,
        isPublished: false,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.id !== undefined)
        result.id = tsValueToJsonValueFns.uint64(value.id);
    result.goods = value.goods.map(value => encodeJson_1(value));
    if (value.renewalInterval !== undefined)
        result.renewalInterval = tsValueToJsonValueFns.enum(value.renewalInterval);
    if (value.saleConfig !== undefined)
        result.saleConfig = encodeJson_2(value.saleConfig);
    if (value.paymentConfig !== undefined)
        result.paymentConfig = encodeJson_3(value.paymentConfig);
    if (value.displayConfig !== undefined)
        result.displayConfig = encodeJson_4(value.displayConfig);
    if (value.isPublished !== undefined)
        result.isPublished = tsValueToJsonValueFns.bool(value.isPublished);
    return result;
}
export function decodeJson(value) {
    var _a, _b;
    const result = getDefaultValue();
    if (value.id !== undefined)
        result.id = jsonValueToTsValueFns.uint64(value.id);
    result.goods = (_b = (_a = value.goods) === null || _a === void 0 ? void 0 : _a.map((value) => decodeJson_1(value))) !== null && _b !== void 0 ? _b : [];
    if (value.renewalInterval !== undefined)
        result.renewalInterval = jsonValueToTsValueFns.enum(value.renewalInterval);
    if (value.saleConfig !== undefined)
        result.saleConfig = decodeJson_2(value.saleConfig);
    if (value.paymentConfig !== undefined)
        result.paymentConfig = decodeJson_3(value.paymentConfig);
    if (value.displayConfig !== undefined)
        result.displayConfig = decodeJson_4(value.displayConfig);
    if (value.isPublished !== undefined)
        result.isPublished = jsonValueToTsValueFns.bool(value.isPublished);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.id !== undefined) {
        const tsValue = value.id;
        result.push([1, tsValueToWireValueFns.uint64(tsValue)]);
    }
    for (const tsValue of value.goods) {
        result.push([2, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.renewalInterval !== undefined) {
        const tsValue = value.renewalInterval;
        result.push([3, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    if (value.saleConfig !== undefined) {
        const tsValue = value.saleConfig;
        result.push([4, { type: WireType.LengthDelimited, value: encodeBinary_2(tsValue) }]);
    }
    if (value.paymentConfig !== undefined) {
        const tsValue = value.paymentConfig;
        result.push([5, { type: WireType.LengthDelimited, value: encodeBinary_3(tsValue) }]);
    }
    if (value.displayConfig !== undefined) {
        const tsValue = value.displayConfig;
        result.push([6, { type: WireType.LengthDelimited, value: encodeBinary_4(tsValue) }]);
    }
    if (value.isPublished !== undefined) {
        const tsValue = value.isPublished;
        result.push([7, tsValueToWireValueFns.bool(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.uint64(wireValue);
        if (value === undefined)
            break field;
        result.id = value;
    }
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 2).map(([, wireValue]) => wireValue);
        const value = wireValues.map((wireValue) => wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined).filter(x => x !== undefined);
        if (!value.length)
            break collection;
        result.goods = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.renewalInterval = value;
    }
    field: {
        const wireValue = wireFields.get(4);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_2(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.saleConfig = value;
    }
    field: {
        const wireValue = wireFields.get(5);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_3(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.paymentConfig = value;
    }
    field: {
        const wireValue = wireFields.get(6);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_4(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.displayConfig = value;
    }
    field: {
        const wireValue = wireFields.get(7);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.bool(wireValue);
        if (value === undefined)
            break field;
        result.isPublished = value;
    }
    return result;
}
